import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TaskSdkService, Task, KeyValueTypes } from '@vendasta/task';
import { map, switchMap } from 'rxjs/operators';
import { TaskInterface } from '@vendasta/task/lib/_internal/interfaces/task.interface';
import { AUTOMATION_NAMESPACE_INJECTION_TOKEN$ } from '@galaxy/automata/shared';

const EMPTY_PATH = '/';

@Injectable({ providedIn: 'root' })
export class TaskService {
  constructor(
    private readonly taskService: TaskSdkService,
    @Inject(AUTOMATION_NAMESPACE_INJECTION_TOKEN$) public readonly namespace$: Observable<string>,
  ) {}

  getTask(accountGroupId: string, taskId: string): Observable<Task> {
    return this.namespace$.pipe(
      switchMap((partnerId) =>
        this.taskService.getTask(
          TaskSdkService.buildAccountGroupNamespace(partnerId, accountGroupId),
          EMPTY_PATH,
          taskId,
        ),
      ),
    );
  }

  searchTasks(
    partnerId: string,
    access: string,
    searchTerm: string,
    forProjects: boolean,
  ): Observable<TaskInterface[]> {
    // do not request "Project" type of task: unless explicitly asked for
    let types = [
      'Review',
      'SocialPost',
      'Socialize',
      'Onboarding',
      'Generic',
      'ClientReview',
      'ScheduleSocialPosts',
      'Meeting',
      'QuestionAndAnswer',
      'Visibility',
      'Mention',
      'Template/Generic',
    ];
    if (forProjects) {
      types = ['Project', 'Template'];
    }
    const request = {
      metadata: {
        keyValues: [
          {
            key: 'partner',
            values: [
              {
                type: KeyValueTypes.STRING,
                stringValue: partnerId,
              },
            ],
          },
        ],
      },
      types: types,
      access: [access],
      titleFuzzy: searchTerm,
      pageSize: 100,
    };
    return this.taskService.search(request).pipe(
      map((resp) => {
        return resp.tasks || [];
      }),
    );
  }
}
